export default String.raw`
$(document).ready(function() {
    contact.init();
});

const contact = {
    init: function() {
        this.events();
    },

    sendContactForm: function(e) {
		if(app.validationBeforePost(e) != 'error'){
			$('.during-ajax-modal-js').removeClass('hidden-js');
			const form = $(e.currentTarget).parents('.form-js');
			const dataFromHTML = form.find('input:not([disabled]), select:not([disabled]), textarea:not([disabled])').serializeArray();
			const fileList = window.attachementsInComplaint;
			let filesSize = 0;
			if(fileList != undefined){
				filesSize = fileList.length;
			}
			const fd = new FormData();
			fd.append('__csrf', __CSRF);
			for(const field of dataFromHTML){
				fd.append(field.name, field.value);
			}
			if (filesSize > 0) {
				window.AttachementsErrors = 0;
				function addAttachementError(file, message) {
					if(window.AttachementsNotAdded == undefined){
						window.AttachementsNotAdded = [];
					}
					const attachement = '<div style="padding: 20px;"><strong>'+file.name+'</strong>: '+message+'</div>';
					window.AttachementsNotAdded.push(attachement);
					window.AttachementsErrors += 1;
				};
				const input = form.find('[name=file]').eq(0);
				const extensions = input.attr('accept').split(', ');
				const fileSize = input.data('file-size');
				for (let i=0; i<filesSize; i++) {
					const file = fileList.pop();
					if(file.size < fileSize){
						const extensionArr = file.name.split('.');
						const extension = '.' + extensionArr[extensionArr.length - 1].toLowerCase();
						let wrongExtension = true;
						for(const ext of extensions){
							if(extension == ext){
								fd.append('file'+i, file);
								wrongExtension = false;
							}
						}
						if(wrongExtension){
							const message = input.data('invalid-file');
							addAttachementError(file, message);
						}
					} else {
						const message = input.data('size-exceeded');
						addAttachementError(file, message);
					}
				}
				if(window.AttachementsNotAdded){
					const popup = '<div class="message-popup-background container-to-delete-js">'+
									'<div class="data-form__header message-popup-on-background-js">'+
										'<span>'+
											__translations.AttachementsNotAdded+
										'</span>'+
										'<form method="dialog">'+
											'<button class="close-button close-js" aria-label="'+__translations.Close+'">'+
												'<svg width="24" height="24" class="svgIcon"><use xlink:href="css/img/fontawesome-icons.svg?v=' + __lqTS + '#times-'+__iconStyle+'"></use></svg>'+
											'</button>'+
										'</form>'+
										'<div class="info">'+
											'<div>'+
												window.AttachementsNotAdded.join('')+
											'</div>'+
										'</div>'+
									'</div>'+
								'</div>';
					const modal = document.querySelector('.info-popup-js');
					modal.innerHTML = popup;
					modal.showModal();
					window.AttachementsNotAdded = undefined;
					window.AttachementsErrors = undefined;
				}
			}
			$.ajax({
				data: fd, processData: false, contentType: false, type: 'POST',
				success: function (data) {

					$('.during-ajax-modal-js').addClass('hidden-js');
					$('.add-attachement-in-complaint-js').val('');
					if (data.action.Result) {
						const message = form.data('success');
						app.temporaryPopupMessage(form, message, 'msg');

						form.find('.message-js').remove();
						$('.custom-input-file-container-js').addClass('hidden-js');
						form.find('input[type="text"], input[type="email"], input[type="tel"], textarea').val('');
						app.formLabelAnimationOnLoadPage();
						form.find('.characters-counter-js').addClass('hidden-js');
					} 
					else {
						const messageType = data.action.Type;
						const message = '<p>' + data.action.Message + '</p>';
						if(data.action.Code != 100){
							app.temporaryPopupMessage(form, message, messageType);
						}
					}
				}
			});
			$(e.currentTarget).removeClass('error-js');
		} else {
			$(e.currentTarget).addClass('error-js');
		}
	},

    events: function() {
        $('body').on('click', '.send-contact-form-js', function(e) {
			contact.sendContactForm(e);
		});
    }
}
`